import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {ModalsService} from "../../../../../../../core/services/modals.service";
import {ProductPackageData} from "../../types/product-packages-modal.types";
import {ProductPackagesFormFieldService} from "../../services/product-packages-form-field.service";
import {MatIcon} from "@angular/material/icon";
import {MatMiniFabButton} from "@angular/material/button";

@Component({
  selector: 'app-product-packages-accordion-title',
  imports: [
    MatIcon,
    MatMiniFabButton
  ],
  templateUrl: './product-packages-accordion-title.component.html',
  styleUrl: './product-packages-accordion-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPackagesAccordionTitleComponent {
  productPackage = input.required<ProductPackageData>();
  isEditModeActive = input<boolean>(false);
  deleteRecord = output<number>();

  private productPackagesFormFieldService: ProductPackagesFormFieldService = inject(ProductPackagesFormFieldService);
  private modalService: ModalsService = inject(ModalsService);

  public getSizeParams(): string {
    return `${this.productPackage().length || 0}x${this.productPackage().width || 0}x${this.productPackage().height || 0}`;
  }

  public getSWightQuantityParams(): string {
    return `${this.productPackage().weight || 0} - ${this.productPackage().quantity || 0}`;
  }

  public async handleBtnClick(event: MouseEvent, key: string): Promise<void> {
    event.stopPropagation();
    const handle: Record<string, ()  => Promise<void>> = {
      history: () => this.handleOpenHistoryModal(),
      delete: () => this.handleDelete()
    }

    await handle[key]?.();
  }

  private async handleOpenHistoryModal(): Promise<void> {
    this.modalService.openHistoryChangesModal({
      historyChangesData: this.productPackage().history || [],
      columnKey: 'productPackages'
    });
  }

  private async handleDelete(): Promise<void> {
    const id = this.productPackage().id;
    const isConfirmed = await this.productPackagesFormFieldService.isDeleteConfirmed(id);
    if (!isConfirmed) { return; }

    this.deleteRecord.emit(id);
  }
}
